import { dataHooks } from '@wix/data-hooks'

export const wixMobileBusinessNameDataHooks = dataHooks<{
  stepProgressBar: {}
  title: {}
  subtitle: {}
  input: {}
  primaryBtn: {}
  back: {}
  skip: {}
}>('wix-mobile-business-name')
